import { useEffect, useState} from 'react';
import axios from "axios";
import {axiosInstance} from "./axiosInstance";
function ContentHtml() {

    // Guardar HTML
    const [htmlRes, setHtmlRes] = useState();

    //Obtener los datos de la respuesta
    // const { state } = useLocation();
    //console.log(state); // null
    // useEffect(() => {
        // Sí hay datos que vengan de useNavigate se renderizan esos datos, en caso contrario se hace la peticion al servidor
      // state ? ( setHtmlRes(state) ) : (
      //     axios.get('http://localhost/fiducia/api/v2/zTest/response/html')
      //         .then( res => {
      //             setHtmlRes(res.data);
      //         })
      //         .catch(error => console.error("Error: ", error))
      // )
    // }, [state]);

    // HTML del servidor, solo se ejecuta una vez
    useEffect(() => {
        axiosInstance.get('zTest/response/html')
            .then( res => {
                setHtmlRes(res.data);
            })
            .catch(error => console.error("Error: ", error));
    }, []);


    useEffect(() => {
        // Obtener en fragmento de html que se recivio siempre tiene qe estar dentro del una etiqueta "pre"
        const scriptElements = document.querySelectorAll('pre');

        scriptElements.forEach((pre) => {
            // Se búscan las etiquetas "a" que haya dentro de las etiquetas "pre"
            const aElements = pre.querySelectorAll('a');
            aElements.forEach((a) => {
                const ref = a.href;
                a.onclick = function (){
                    a.removeAttribute('href');
                    axios.get(ref)
                        .then( res => {
                            setHtmlRes(res.data);
                        })
                        .catch(error => console.error("Error: ", error));
                }
            });
            // Se búscan los escript que haya dentro de las etiquetas "pre"
            const script = pre.querySelectorAll('script');
            // Por cada script se crea uno
            script.forEach((s) => {
                const newScript = document.createElement('script');
                newScript.src = s.src;
                document.body.appendChild(newScript);
                // Se elimina el script que no se toma como etiqueta
                s.remove();
            })
        })
    }, [htmlRes]);

    return (
        <div className="content d-flex flex-column flex-column-fluid" id="kt_content">
            {
                htmlRes ? (
                    <div dangerouslySetInnerHTML={{__html: htmlRes}}/>
                ): (
                    <div>No hay nada para mostrar</div>
                )
            }
        </div>
    );
}

export default ContentHtml;
